import React from "react";

interface Props {
    renderImageOtherPerson: JSX.Element | null;
    messageOrFile: JSX.Element;
    dateTime: string;
}

const DiscussionOtherMessage: React.FC<Props> = ({ renderImageOtherPerson, messageOrFile, dateTime }) => {
    return (
        <div className="flex items-end gap-2 mb-3 px-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full overflow-hidden bg-secondary flex items-center justify-center text-xs font-semibold text-secondary-foreground">
                {renderImageOtherPerson}
            </div>
            <div className="max-w-[72%]">
                <div className="bg-white rounded-2xl rounded-bl-sm px-4 py-2.5 text-sm leading-relaxed shadow-sm border border-border">
                    {messageOrFile}
                </div>
                <span className="text-xs text-muted-foreground mt-1 block">{dateTime}</span>
            </div>
        </div>
    );
};

export default DiscussionOtherMessage;
